<template>
  <div class="credential-field">
    <p v-if="label" class="credential-field__label">{{ label }}</p>
    <div class="credential-field__row">
      <code class="credential-field__value" :aria-label="label">{{
        displayValue
      }}</code>
      <button
        v-if="secret"
        type="button"
        class="credential-field__icon-btn"
        :aria-label="visible ? 'Hide ' + label : 'Show ' + label"
        :title="visible ? 'Hide' : 'Show'"
        @click="visible = !visible"
      >
        <v-icon size="18">{{
          visible ? "mdi-eye-off-outline" : "mdi-eye-outline"
        }}</v-icon>
      </button>
      <button
        type="button"
        class="credential-field__icon-btn"
        :aria-label="'Copy ' + label"
        title="Copy"
        v-clipboard:success="onCopied"
        v-clipboard="() => value"
      >
        <v-icon size="18">{{ copied ? "mdi-check" : "mdi-content-copy" }}</v-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CredentialField",
  props: {
    label: { type: String, default: "" },
    value: { type: String, required: true },
    secret: { type: Boolean, default: false },
  },
  data() {
    return {
      visible: false,
      copied: false,
    };
  },
  computed: {
    displayValue() {
      if (this.secret && !this.visible) {
        return "•".repeat(Math.min(Math.max(this.value.length, 8), 24));
      }
      return this.value;
    },
  },
  methods: {
    onCopied() {
      this.copied = true;
      this.$notify({
        group: "main",
        text: `Copied ${this.label || "value"}`,
        duration: 1200,
      });
      setTimeout(() => {
        this.copied = false;
      }, 1400);
    },
  },
};
</script>

<style scoped lang="scss">
.credential-field {
  &__label {
    font-size: 12px;
    font-weight: 500;
    color: rgba(15, 23, 42, 0.62);
    margin: 0 0 6px;
  }

  &__row {
    display: flex;
    align-items: stretch;
    gap: 0;
    background-color: #f8f8fb;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 8px;
    overflow: hidden;
    min-height: 40px;
  }

  &__value {
    flex: 1;
    padding: 10px 14px;
    font-family: "SF Mono", "Menlo", "Monaco", "Consolas", monospace;
    font-size: 13px;
    color: #0f172a;
    background: transparent;
    word-break: break-all;
    overflow-x: auto;
    line-height: 1.4;
    display: flex;
    align-items: center;
  }

  &__icon-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    min-width: 40px;
    background: transparent;
    border: none;
    border-left: 1px solid rgba(15, 23, 42, 0.06);
    cursor: pointer;
    color: rgba(15, 23, 42, 0.6);
    transition: background-color 120ms ease, color 120ms ease;

    &:hover {
      background-color: rgba(226, 120, 47, 0.08);
      color: #e2782f;
    }

    &:focus-visible {
      outline: 2px solid #e2782f;
      outline-offset: -2px;
    }
  }
}
</style>
